export default __webpack_public_path__ + "static/media/tqicon-3.5dd11464.svg";